const roles = {
  device: 'ROLE_DEVICE',
}

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    // if (hasAuthor(roles.admin)) {
    //   return '/handle-system.html'
    // } else if (hasAuthor(roles.user)) {
    //   return '/handle-system.html'
    // } else {
      return '/player.html'
    // }
  },

  authorizationMapper: [
    {
      regex: /^\/player.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.device)
      }
    },
    // {
    //   regex: /^\/.*\/story.html/,
    //   isAuthorized: function (hasAuthor) {
    //     return hasAuthor(roles.admin)|| hasAuthor(roles.customer)
    //   }
    // },
  ]
}



// WEBPACK FOOTER //
// ./src/security/config.js